import { ApolloError } from '@apollo/client';

import InlineServerError from 'approot/errors/inline-server-error';
import ErrorMessageStyled from 'approot/shared/error-message/error-message.style';
import {
  NSW_EDUCATION_EMAIL_DOMAIN,
  SSO_DET_NSW_EMAIL_DOMAIN,
} from 'global/constants';
import { VALIDATION_MESSAGE_EMAIL_NOT_EDUCATION } from 'webclient.constants';
import { FlowEmailValidation_emailValidation } from './__generated__/FlowEmailValidation';
import { useRegionData } from 'approot/shared/region/region.apollo';
import { LinkButton } from 'approot/shared/styles/buttons/buttons';
import { INTERCOM_LAUNCH_TARGET_CLASS } from 'lib/intercom/intercom';
import { Box } from 'approot/shared/styles/box.style';
import { ValidSpacings } from 'approot/shared/styles/spacing.style';

export const FlowEmailValidationMessages = ({
  validationResult,
  error,
  marginBottom,
}: {
  validationResult: FlowEmailValidation_emailValidation[] | undefined;
  error?: ApolloError | undefined;
  marginBottom?: ValidSpacings;
}) => {
  const { isRegionAU } = useRegionData();

  return (
    <Box $flexDirection="column" $marginBottom={marginBottom}>
      {validationResult?.[0].taken && (
        <ErrorMessageStyled data-selector="error-email-taken">
          This email has been taken, please use another one.
        </ErrorMessageStyled>
      )}

      {validationResult?.[0] && !validationResult[0].isEducation && (
        <ErrorMessageStyled data-selector="error-non-education-email">
          {isRegionAU &&
          validationResult[0].id.includes(NSW_EDUCATION_EMAIL_DOMAIN) ? (
            <>
              Looks like you’re using an{' '}
              <strong>@{NSW_EDUCATION_EMAIL_DOMAIN}</strong> email, please try
              again with your <strong>@{SSO_DET_NSW_EMAIL_DOMAIN}</strong> email
            </>
          ) : (
            <>
              {VALIDATION_MESSAGE_EMAIL_NOT_EDUCATION}{' '}
              <LinkButton
                error
                type="button"
                className={INTERCOM_LAUNCH_TARGET_CLASS}
                aria-haspopup="dialog"
              >
                Contact us
              </LinkButton>{' '}
              if you don’t have one
            </>
          )}
        </ErrorMessageStyled>
      )}

      {error && <InlineServerError />}
    </Box>
  );
};
